module.exports = __webpack_public_path__ + "static/level-0-card.20174e3c.png";